import React from 'react';
import { notification } from 'antd';

export default function handleErrors(response: Response) {
  if (response.status === 401) {
    if (
      window.location.href.slice(
        window.location.href.lastIndexOf('/') + 1,
        window.location.href.length
      ) !== 'login'
    ) {
      window.history.replaceState(null, '', '/login');
      localStorage.clear();
      window.location.reload();
    }
  }
  if (response.status === 417) {
    response.json().then((result) => {
      notification.error({
        message: result?.message,
        description: (
          <>
            {JSON.parse(result?.description).map(
              ({ ccode, message }: any, index: number) => (
                <p key={index}>
                  {ccode} - {message}
                </p>
              )
            )}
          </>
        ),
        duration: null,
      });
      return;
    });
  }

  return response;
}
